import React from "react";
import management1 from "../assets/management1.png";
import management2 from "../assets/management2.png";
import management3 from "../assets/management3.png";
import management4 from "../assets/management4.png";

const Management = () => {
    const members = [
        {
            name: "Thiru. R. Sakkarapani",
            role: "Minister for Food and Civil Supplies, Tamil Nadu",
            image: management1,
        },
        {
            name: "Thiru. Sathyabrata Sahoo, I.A.S.",
            role:
                "Principal Secretary to Government, Co-operation, Food and Consumer Protection Department.",
            image: management2,
        },
        {
            name: "Thiru. B. Ranganathan, B.A., LL.B.",
            role: "Ex MLA/Chairman, Tamil Nadu Warehousing Corporation",
            image: management3,
        },
        {
            name: "Tmt. Dr. J. Vijaya Rani, I.A.S.",
            role: "Managing Director, Tamil Nadu Warehousing Corporation.",
            image: management4,
        },
    ];

    return (
        <div className="container py-5">
            <h2 className="text-center fw-bold mb-4" data-aos="fade-down">
                Management Team
            </h2>

            <div className="row justify-content-center">
                {members.map((member, index) => (
                    <div className="col-md-3 mb-4" key={index}>
                        <div className="card shadow-sm text-center border-0 h-100">

                            {/* Blue Header */}
                            <div
                                className="py-3"
                                style={{ backgroundColor: "#2f86d6" }}
                            >
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="img-fluid rounded"
                                    style={{
                                        height: "220px",
                                        objectFit: "cover",
                                        backgroundColor: "#fff",
                                        padding: "5px",
                                    }}
                                />
                            </div>

                            {/* Card Body */}
                            <div className="card-body">
                                <h6 className="text-primary fw-semibold">
                                    {member.name}
                                </h6>
                                <p className="text-danger small mt-2">
                                    {member.role}
                                </p>
                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Management;